import { render, staticRenderFns } from "./dividerTitle.vue?vue&type=template&id=74b0c596&"
import script from "./dividerTitle.vue?vue&type=script&lang=js&"
export * from "./dividerTitle.vue?vue&type=script&lang=js&"
import style0 from "./dividerTitle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports